import { Component } from "@angular/core";
import { SignUpSimulatorComponent } from "../simulator/sign-up-simulator.component";
import { SharedModule } from "src/app/shared/shared.module";
import { SignUpOutingComponent } from "../outing/sign-up-outing.component";
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'sign-up-shell',
    template: `
        <div class="sign-up-shell-outer">
          <div class="sign-up-shell-inner">
            <div class="d-flex justify-content-center mt-4">
              <mat-radio-group [(ngModel)]="selectedSignUp" aria-label="Sign Up Type">
                <mat-radio-button value="simulator" class="me-3">Simulator</mat-radio-button>
                <mat-radio-button value="outing">Outing</mat-radio-button>
              </mat-radio-group>
            </div>
            <ng-container *ngIf="selectedSignUp === 'simulator'">
              <sign-up-simulator></sign-up-simulator>
            </ng-container>
            <ng-container *ngIf="selectedSignUp === 'outing'">
              <sign-up-outing></sign-up-outing>
            </ng-container>
          </div>
        </div>
    `,
    styles: `
        .sign-up-shell-outer {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f5f5f5;
        }
        .sign-up-shell-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
    `,
    standalone: true,
    imports: [SharedModule, SignUpSimulatorComponent, SignUpOutingComponent, MatRadioModule, FormsModule, MatCardModule]
})
export class SignUpShellComponent {
    selectedSignUp: 'simulator' | 'outing' = 'simulator';
}